module.exports = __webpack_public_path__ + "img/panorama-after-LM.551fa03d.jpg";